import { render, staticRenderFns } from "./TechDisplay.vue?vue&type=template&id=ad63431e&scoped=true"
import script from "./TechDisplay.vue?vue&type=script&lang=js"
export * from "./TechDisplay.vue?vue&type=script&lang=js"
import style0 from "./TechDisplay.vue?vue&type=style&index=0&id=ad63431e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad63431e",
  null
  
)

export default component.exports